import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import {LoginPage} from "../pages/login/login";
import {ConfigProvider} from "../providers/config/config";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  tokenIsPresent: boolean;
  pages: Array<{title: string, component: any}>;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private configProvider: ConfigProvider) {

    this.configProvider.load().then(
      data => {
        this.initializeApp();

        if (localStorage.getItem("token"))
          this.tokenIsPresent = true;

        this.pages = [];

        if (this.tokenIsPresent)
          this.rootPage = HomePage;
        else
          this.rootPage = LoginPage;
      }
    );
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts